<template>
    <div class="context-wrapper">
        <div class="content-body">
            <b-row>
                <b-col md="12">
                    <b-overlay
                        :show="status === 'loading'"
                    >
                        <CloudFrontResourceDailyChart
                            :data="distributionDates"
                            :yKeys="distributionIds"
                            :themeColors="themeColors"
                        />
                    </b-overlay>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="7">
                    <b-overlay
                        :show="status === 'loading'"
                    >
                        <CloudFrontTypeValueList
                            :regionMap="regionMap"
                            :data="typeValues"
                            :themeColors="themeColors"
                        />
                    </b-overlay>
                </b-col>
                <b-col md="5">
                    <b-overlay
                        :show="status === 'loading'"
                    >
                        <CloudFrontResourceList
                            :data="distributions"
                            :themeColors="themeColors"
                        />
                    </b-overlay>
                </b-col>

            </b-row>
        </div>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { getCurrentInstance, computed, inject, watch, toRefs } from '@vue/composition-api'
import CloudFrontResourceDailyChart from './_components/CloudFrontResourceDailyChart'
import CloudFrontResourceList from './_components/CloudFrontResourceList'
import CloudFrontTypeValueList from './_components/CloudFrontTypeValueList'
export default {
    name: 'CloudFrontModule',
    props: ['project', 'month'],
    components: {
        CloudFrontResourceDailyChart,
        CloudFrontResourceList,
        CloudFrontTypeValueList
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const themeColors = inject('themeColors')
        const theme = inject('theme')
        const { region } = useCommonData()
        const { project, month } = toRefs(props)
        const regionMap = computed(() => {
            return region.value.reduce((accumulator, currentValue) => {
                accumulator[currentValue.key] = {
                    name: currentValue.name,
                    code: currentValue.code
                }
                return accumulator
            }, {})
        })
        const status = computed(() => store.getters['$_cloudfront/status'])
        const distributionDates = computed(() => store.getters['$_cloudfront/distributionDates'])
        const typeValues = computed(() => store.getters['$_cloudfront/typeValues'])
        const distributions = computed(() => store.getters['$_cloudfront/distributions'])
        const distributionIds = computed(() => store.getters['$_cloudfront/distributionIds'])
        const getCloudFront = ({ projectIdx, month }) => store.dispatch('$_cloudfront/getCloudFront', { projectIdx, month })
        watch(project, (value, oldValue) => {
            getCloudFront({ projectIdx: value.projectIdx, month: month.value })
        }, {
            deep: true
        })
        watch(month, (value, oldValue) => {
            getCloudFront({ projectIdx: project.value.projectIdx, month: value })
        })

        return {
            status,
            regionMap,
            theme,
            themeColors,
            distributionDates,
            typeValues,
            distributions,
            distributionIds
        }
    }
}
</script>

<style>

</style>
